import ProjectConfigGeneral from './ProjectGeneralConfig'

export default ProjectConfigGeneral
